"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _navigationArrows = require("./navigationArrows");
Object.keys(_navigationArrows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _navigationArrows[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _navigationArrows[key];
    }
  });
});
var _pagination = require("./pagination");
Object.keys(_pagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pagination[key];
    }
  });
});
var _root = require("./root");
Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _root[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _root[key];
    }
  });
});
var _header = require("./header");
Object.keys(_header).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _header[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _header[key];
    }
  });
});
